import React, { useEffect } from 'react';
import '../styles/term-of-service.css';
import { useSettings } from '../context/SettingsContext';

const PrivacyPolicyPage = () => {
    const { privacyPolicy } = useSettings();

    useEffect(() => {
        document.title = 'Iampesmobile - Chính sách bảo mật';
    }, []);

    return (
        <div className="terms-container">
            <h1>Chính sách bảo mật</h1>
            <div className="terms-list">
                {privacyPolicy.map(term => (
                    <div key={term.id} className="term-item">
                        <h2 className="term-title">{term.title}</h2>
                        <p className="term-content">{term.content}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;
